"use strict";

export var SystemConfig = {
  MainForm: {
    Logo: 'favicon.ico',
    Title: 'TNS panel',
    TopBarTitle: 'TNS panel',
    DocumentTitlePrefix: 'TNS panel: ',
    LoginTitle: 'Director 5'
  }
};